import React, { useState } from 'react'
import { Outlet } from 'react-router'
import MainNavbar from 'src/components/layouts/MainNavbar'
import MainContent from 'src/components/layouts/MainContent'
import MainSidebar from 'src/components/layouts/MainSidebar'

const MasterLayout = () => {
    const [sidebarToogle, setSidebarToogle] = useState(false)
    return (
        <div className='master_wrapper' >
            <MainNavbar sidebarToogle={sidebarToogle} setSidebarToogle={setSidebarToogle} />
            <div className='main_wrapper'>
                <MainSidebar sidebarToogle={sidebarToogle} setSidebarToogle={setSidebarToogle} />
                <MainContent>
                    <Outlet />
                </MainContent>
            </div>
        </div>
    )
}

export default MasterLayout